import { ElementRef } from "@angular/core";
import { Params } from "@angular/router";
import moment from 'moment';
import { environment } from "../../environments/environment";
import { PlatForm } from "../models";
declare var window: any;
export class Helpers {

  static getFormattedCurrentDate() {
    return moment().format("YYYY-MM-DD hh:mm A"); // 12H clock
  }

  static getFormattedCurrentDateWithoutTime() {
    return moment().format("DD-MMM-YYYY"); // 12H clock
  }

  static copyToClipboard(value: string, json: boolean = false) {
    const textArea = document.createElement("textarea");
    if (json) {
      value = this.formatTextToJson(value);
    }
    textArea.value = value;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand("copy");
    document.body.removeChild(textArea);
  }

  static formatTextToJson(text: string) {
    return JSON.stringify(JSON.parse(text), null, 2);
  }

  static async asyncForEach(array: Array<any>, callback: Function) {
    for (let index = 0; index < array.length; index++) {
      await callback(array[index], index, array);
    }
  }

  static getTimes(interval: number) {
    const times = [];
    let startTime = 0;
    const ap = ["AM", "PM"];

    for (let i = 0; startTime < 24 * 60; i++) {
      const hh = Math.floor(startTime / 60); // getting hours of day in 0-24 format.
      const mm = startTime % 60; // getting minutes of the hour in 0-55 format.
      times[i] =
        ("" + (hh === 0 || hh === 12 ? 12 : hh % 12)).slice(-2) +
        ":" +
        ("0" + mm).slice(-2) +
        " " +
        ap[Math.floor(hh / 12)];
      startTime = startTime + interval;
    }

    return times;
  }

  static setTimeToDate(date: Date, time: string) {
    const parts = time.match(/(\d+):(\d+) ([AaPp][Mm])/);
    if (parts != null) {
      let hours = +parts[1];
      const minutes = +parts[2];
      const format: string = parts[3].toUpperCase();

      if (format === "PM" && hours < 12) {
        hours += 12;
      } else if (format === "AM" && hours === 12) {
        hours = 0;
      }

      if (moment.isMoment(date)) {
        return date.startOf("day").add(hours, "hours").add(minutes, "minutes");
      }

      date.setHours(hours, minutes);
    }
    return date;
  }

  static isNullOrUndefined(object: any): boolean {
    return object === undefined || object === null;
  }

  static removeEditHighlightClass(elementRef: ElementRef) {
    elementRef.nativeElement
      .querySelectorAll(
        ".leftborder_highlighted, .border-highlighted-radio, .border-highlighted-toggle, .border-highlighted-checkbox"
      )
      .forEach((element: any) => {
        element.classList.remove("leftborder_highlighted");
        element.classList.remove("border-highlighted-radio");
        element.classList.remove("border-highlighted-toggle");
        element.classList.remove("border-highlighted-checkbox");
      });
  }

  static groupBy(value: Array<any>, field: string): Array<any> {
    const groupedObj = value.reduce((prev, cur) => {
      (prev[cur[field]] = prev[cur[field]] || []).push(cur);
      return prev;
    }, {});
    return Object.keys(groupedObj).map((key) => ({
      key,
      value: groupedObj[key],
    }));
  }

  static IsLocal() {
    return window.location.host.toLowerCase().indexOf('localhost') == 0;
  }

  static getPlatformId(): PlatForm {
    let platformId;
    if(this.IsLocal() || window.location.host.indexOf('triport') == 0){
      platformId = PlatForm.TriPort;
    }else if (window.location.host.indexOf('cloudport') == 0){
      platformId = PlatForm.CloudPort;
    }else if (window.location.host.indexOf('studystat') == 0 ){
      platformId = PlatForm.StudyStat;
    }else{
      platformId = PlatForm.RaspberryAI;
    }
    return platformId;
  }

  static getPlatformName(): string {
    let platform = "";
    if(Helpers.getPlatformId() == <number>PlatForm.TriPort){
      platform = "TriPort";
    }else if( Helpers.getPlatformId() == <number>PlatForm.CloudPort){
      platform = "CloudPort";
    }else if( Helpers.getPlatformId() == <number>PlatForm.StudyStat){
      platform = "StudyStat";
    }else{
      platform = "RASPberry AI";
    }
    return platform;
  }
  static getPlatformLogo(): string {
    let logo = "";
    let platformId = Helpers.getPlatformId();
    if(platformId == <number>PlatForm.TriPort){
      logo = environment.cdnEndPoint + "/medpointapps/img/AppLogos/TriPort_color.svg";
    }else if(platformId == <number>PlatForm.CloudPort){
      logo = environment.cdnEndPoint + "/shared/logos/CloudPort_color.svg";
    }else if(platformId == <number>PlatForm.StudyStat){
      logo = environment.cdnEndPoint + "/medpointapps/img/app-logos/StudyStat_color.svg";
    }else{
      logo = environment.cdnEndPoint + "/medpointapps/img/app-logos/RASPberryAI_color.svg"
    }
    return logo;
  }
 static getPlatformIcon(): string {
    let logo = "";
    let platformId = Helpers.getPlatformId();
    if(platformId == <number>PlatForm.TriPort){
      logo = environment.cdnEndPoint + '/triport/icons/Triport_V10.ico';
    }else if(platformId == <number>PlatForm.CloudPort){
      logo = environment.cdnEndPoint + '/cloudport/icons/CloudPort.ico';
    }else if(platformId == <number>PlatForm.StudyStat){
      logo = environment.cdnEndPoint + '/triport/icons/StudyStat.ico';
    }else{
      logo = environment.cdnEndPoint + '/triport/icons/RaspberryAI.ico';
    }
    return logo;
  }
  static getApplicationUrl(): string {
    let urlprotocol = this.IsLocal() ? "http://" : "https://";
    let url = urlprotocol + window.location.host;
    return url;
  }
  static getAdminAppUrl(): string {
    let platformId = Helpers.getPlatformId()
    let url = "";
    if(platformId == <number>PlatForm.TriPort){
      url = environment.triportAdminAppUrl;
    }else if(platformId == <number>PlatForm.CloudPort){
      url = environment.cloudportAdminAppUrl;
    }else if(platformId == <number>PlatForm.StudyStat){
      url = environment.studystatAdminAppUrl
    }else{
      url = environment.raspberryAIAdminAppUrl;
    }
    return url;
  }

  static isMedPointUser(email: string) {
    return email.toLowerCase().indexOf('@medpt.com') != -1;
  }

  static toLowerQueryParams(params: Params): Params {
    const lowerParams: Params = {};
    for (const key in params) {
      lowerParams[key.toLowerCase()] = params[key];
    }

    return lowerParams;
  }
  static getPlaintTextFromHTML(value: string): string {
    var temporalDivElement = document.createElement("div");
    temporalDivElement.innerHTML = value;
    return temporalDivElement.textContent || temporalDivElement.innerText || "";
  }

  static decodeEntity(inputStr: string): string {
    var textarea = document.createElement("textarea");
    textarea.innerHTML = inputStr;
    return textarea.value;
  };

  static unixTimeConvertToDateTime(UNIX_timestamp: number, format: string | null): string {
    let time = moment.unix(UNIX_timestamp).format("DD/MMM/YYYY hh:mm:ss A");
    if (format != null)
      time = moment(time).format(format);
    return time;
  }

  static getQueryParamValue(queryString:string, prop:string) {
    var proxyObject:any = new Proxy(new URLSearchParams(queryString), {
      get: (searchParams, prop: string) => searchParams.get(prop),
    });
    return proxyObject[prop];
  }

  static b64toBlob(b64Data: string, contentType: string = '', sliceSize: number = 512): Blob {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }
  
  static toDateString(date: Date | null): string | null {
    if (!date) return null;

    const yyyy = date.getFullYear();
    const mm = ('0' + (date.getMonth() + 1)).slice(-2);
    const dd = ('0' + date.getDate()).slice(-2);

    return `${yyyy}-${mm}-${dd}`;
  }

  static toLocalMidnight(date: Date): Date {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }
  
}
